// notification-bell.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationBellService {
  private _showBell = new BehaviorSubject<boolean>(true);
  showBell$ = this._showBell.asObservable();

  show() { this._showBell.next(true); }
  hide() { this._showBell.next(false); }
}